<nz-page-header class="site-page-header">
  <nz-breadcrumb nz-page-header-breadcrumb>
    <nz-breadcrumb-item>
      <a [routerLink]="['/home/dashboard']"><em nz-icon nzType="home"></em></a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item><a [routerLink]="['/home/marketplace/banners']">Marketplaces</a></nz-breadcrumb-item>
    <nz-breadcrumb-item>{{ bannerId ? 'Editar Banner' : 'Novo Banner' }}</nz-breadcrumb-item>
  </nz-breadcrumb>
  <nz-page-header-title>{{ bannerId ? 'Editar Banner' : 'Criar Novo Banner' }}</nz-page-header-title>
  <nz-page-header-subtitle>Configure os detalhes visuais e as regras de exibição.</nz-page-header-subtitle>
  <nz-page-header-extra>
    <button nz-button (click)="cancel()">Cancelar</button>
    <button nz-button nzType="primary" [nzLoading]="isSaving" [disabled]="bannerForm.invalid" (click)="save()">
      <em nz-icon nzType="save"></em>
      Salvar Banner
    </button>
  </nz-page-header-extra>
</nz-page-header>

<main nz-row [nzGutter]="24" class="banner-editor">
  <div nz-col [nzSpan]="16">
    <form nz-form [formGroup]="bannerForm" nzLayout="vertical">
      <ng-template #contentTabTitle>
        <em nz-icon nzType="form"></em>
        Conteúdo do Banner
      </ng-template>
      <ng-template #settingsTabTitle>
        <em nz-icon nzType="setting"></em>
        Configurações de Exibição
      </ng-template>

      <nz-tabset>
        <!-- Aba 1: Conteúdo -->
        <nz-tab [nzTitle]="contentTabTitle">
          <nz-form-item>
            <nz-form-label nzRequired>Título do Banner</nz-form-label>
            <nz-form-control nzErrorTip="Informe o título.">
              <input nz-input formControlName="title" placeholder="Ex: Consulta Antecedentes Criminais" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>Descrição</nz-form-label>
            <nz-form-control>
              <textarea nz-input formControlName="description" rows="3" placeholder="Descrição curta e persuasiva..."></textarea>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>Tópicos Chaves (Lista de destaques)</nz-form-label>
            <nz-form-control>
              <div class="topic-input">
                <input
                  nz-input
                  [(ngModel)]="topicInput"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Destaque (ex: Verificação segura)"
                  (keyup.enter)="addTopic()" />
                <button nz-button nzType="default" (click)="addTopic()"><em nz-icon nzType="plus"></em></button>
              </div>
              <nz-tag *ngFor="let topic of topics; let i = index" nzMode="closeable" (nzOnClose)="removeTopic(i)">{{ topic }}</nz-tag>
            </nz-form-control>
          </nz-form-item>

          <div nz-row [nzGutter]="16">
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label>Texto do Botão</nz-form-label>
                <nz-form-control><input nz-input formControlName="ctaLabel" placeholder="Ex: ADQUIRA AGORA MESMO" /></nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label>Link do Botão (URL)</nz-form-label>
                <nz-form-control><input nz-input formControlName="ctaLink" placeholder="https://..." /></nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <nz-form-item>
            <nz-form-label>Upload da Imagem do Banner</nz-form-label>
            <nz-form-control>
              <label
                class="upload-dropzone"
                [class.is-dragover]="isDragOver"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">
                <input type="file" accept="image/*" (change)="onFileSelected($event)" [disabled]="isUploadingPicture" hidden />

                <ng-container *ngIf="!uploadedPictureUrl">
                  <em nz-icon nzType="cloud-upload" class="upload-icon"></em>
                  <p class="upload-text">
                    <span class="upload-link">Clique para fazer upload</span>
                    ou arraste e solte
                  </p>
                  <span class="upload-hint">Recomendado: 600x300px (PNG, JPG, WebP)</span>
                </ng-container>

                <img *ngIf="uploadedPictureUrl" [src]="uploadedPictureUrl" class="upload-preview" alt="Prévia da imagem" />
              </label>
              <button *ngIf="uploadedPictureUrl" nz-button nzType="link" nzDanger class="upload-remove" (click)="removePicture()">
                <em nz-icon nzType="delete"></em>
                Remover imagem
              </button>
            </nz-form-control>
          </nz-form-item>
        </nz-tab>

        <!-- Aba 2: Configurações de Exibição -->
        <nz-tab [nzTitle]="settingsTabTitle">
          <nz-form-item>
            <nz-form-label nzRequired>Produto Vinculado</nz-form-label>
            <nz-form-control nzErrorTip="Selecione um produto.">
              <nz-select formControlName="product" nzPlaceHolder="Selecione um produto">
                <nz-option *ngFor="let topic of productTopics" [nzValue]="topic.value" [nzLabel]="topic.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>Perfis que podem visualizar</nz-form-label>
            <nz-form-control>
              <label nz-checkbox formControlName="profileOwner">Síndico</label>
              <label nz-checkbox formControlName="profileAdmin">Administrador</label>
              <label nz-checkbox formControlName="profileUser">Morador</label>
              <label nz-checkbox formControlName="profileGatekeeper">Porteiro</label>
              <label nz-checkbox formControlName="profileJanitor">Zelador</label>
            </nz-form-control>
          </nz-form-item>

          <div nz-row [nzGutter]="16">
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label nzRequired>Prioridade</nz-form-label>
                <nz-form-control nzErrorTip="Mínimo 1.">
                  <nz-input-number formControlName="position" [nzMin]="1" [nzStep]="1"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label>Status</nz-form-label>
                <nz-form-control>
                  <nz-switch formControlName="isActive" nzCheckedChildren="Ativo" nzUnCheckedChildren="Inativo"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div nz-row [nzGutter]="16">
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label>Tipo de Condomínio</nz-form-label>
                <nz-form-control>
                  <nz-select formControlName="condoType">
                    <nz-option *ngFor="let opt of condoTypeOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label>Tamanho (Unidades)</nz-form-label>
                <nz-form-control>
                  <nz-select formControlName="sizeRange">
                    <nz-option *ngFor="let range of sizeRanges" [nzValue]="range.value" [nzLabel]="range.label"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
    </form>
  </div>

  <!-- Preview ao vivo -->
  <div nz-col [nzSpan]="8">
    <nz-card nzTitle="Preview ao vivo" class="preview-card">
      <div class="preview-banner">
        <div class="preview-content">
          <h3 class="preview-title">{{ preview.title || 'Título do banner' }}</h3>
          <p class="preview-description">{{ preview.description }}</p>
          <ul class="preview-topics">
            <li class="preview-topic" *ngFor="let topic of topics">
              <em nz-icon nzType="check-circle" nzTheme="fill"></em>
              {{ topic }}
            </li>
          </ul>
          <button type="button" class="preview-cta" *ngIf="preview.ctaLabel">{{ preview.ctaLabel }}</button>
        </div>
        <div class="preview-media" *ngIf="uploadedPictureUrl">
          <img [src]="uploadedPictureUrl" class="preview-image" alt="Imagem do banner" />
        </div>
      </div>
      <p class="preview-hint">Visualização aproximada de como o banner será exibido no app.</p>
    </nz-card>
  </div>
</main>
